parseTokenTimezoneZ